<template>
    <div class="channel-code">
        <div class="header">
            <div class="left">
                <label>{{appName}}>{{channel}}</label>
            </div>
        </div>
        <div class="tool-box">
            <el-tabs v-model="activeName" @tab-click="pageChange(1)">
                <el-tab-pane :label="'累计关注('+(countData.addedSum||0)+')'" name="1"></el-tab-pane>
                <el-tab-pane :label="'已关注('+(countData.currentSum||0)+')'" name="2"></el-tab-pane>
                <el-tab-pane :label="'取消关注('+(countData.unfollowSum||0)+')'" name="3"></el-tab-pane>
            </el-tabs>
            <div class="tool-btn-list">
                <el-input placeholder="请输入粉丝昵称" v-model="name" @keyup.enter.native="pageChange(1)"></el-input>
                <el-button type="warning" @click="pageChange(1)">查询</el-button>
                <el-button type="warning" @click="exportFile">导出</el-button>
            </div>
        </div>
        <div class="body" style="margin-top:0">
            <el-table :data="tableData" border class="omtable" style="width: 100%">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="nickname" label="昵称"></el-table-column>
                <el-table-column prop="kefuName" label="所属客服"></el-table-column>
                <el-table-column prop="latestReplyTime" label="最后会话时间"></el-table-column>
                <el-table-column prop="name" label="关注情况">
                    <template slot-scope="scope">
                        <div v-if="scope.row.enable">
                            已关注<br>
                            {{scope.row.createTime}}
                        </div>
                        <div v-else>
                            取消关注<br>
                            {{scope.row.updateTime}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="地址">
                    <template slot-scope="scope">
                        {{scope.row.country}}{{scope.row.city}}{{scope.row.province}}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="page"  background layout="total,prev, pager, next" @current-change="pageChange" :page-size='10' :total="listCount">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import commom from "../../api/common";
import {ruleTool} from '@/api/mixins'
//当前实例组件
export default {
    mixins: [ruleTool],
    data: () => ({
        id:"",//渠道二维码id
        appName:"",//公众号名称
        channel:"",//渠道名称
        name:"",//查询昵称
        activeName:"1",
        countData:{},
        userId:"",
        listCount:0,
        tableData:[],
        pageNum:1,
        form:{},
        formShow:false
    }),
    components: {},
    mounted() {
        this.userId = this.$tools.getLocal("userinfo").id;
        // this.userId = "1182843377511575552L";
        this.id = this.$route.query.id;
        // this.id = "1257182753744293890L";
        this.appName = this.$route.query.appName;
        this.channel = this.$route.query.channel;
        this.getList();
        this.getCount();
    },
    methods: {
        // 导出
        exportFile(){
            const params = {
                userId:this.userId,
                qrcodeId:this.id,
                nickname:this.name,
                queryType:this.activeName,
            }
            let url = commom.api_root + "/wechatthirdplat/subscriptionQrcode/downloadQrcodeFansData?userId="+this.userId+"&qrcodeId="+this.id
                    +"&nickname="+this.name+"&queryType="+this.activeName
            window.open(url);
        },
        getCount(){
            const params = {
                userId:this.userId,
                id:this.id,
                pageSize:1,
                pageNum:1
            }
            this.$http({
                url:'/wechatthirdplat/subscriptionQrcode/read/list',
                type:'post',
                params: params,
            }).then((data)=> {
                this.countData = data.data[0];
            })
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            const params = {
                userId:this.userId,
                qrcodeId:this.id,
                nickname:this.name,
                queryType:this.activeName,
                pageSize:10,
                pageNum:this.pageNum
            }
            // this.getCount();
            this.$http({
                url:'/wechatthirdplat/subscriptionQrcode/queryQrCodeFans',
                type:'put',
                params: params,
            }).then((data)=> {
                this.tableData = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./channelCode";
</style>
